import _ from 'underscore';

export class CopilotSuggestionsTracker {
  constructor() {
    this.trackingData = {};
    this.initialSuggestionsData = {};
  }

  trackReturnedFinalUrlAssets(recommendedAssets) {
    this.trackingData = this.trackingData || {};
    this.trackingData.finalUrlSuggestions = this.trackingData.finalUrlSuggestions || [];
    const FinalUrls = recommendedAssets.FinalUrls || [];
    this.trackingData.finalUrlSuggestions = _.uniq(_.flatten([this.trackingData.finalUrlSuggestions, FinalUrls]));
  }

  trackReturnedTextAssets(recommendedAssets) {
    this.trackingData = this.trackingData || {};

    this.trackingData.textSuggestions = this.trackingData.textSuggestions || [];

    const headlines = recommendedAssets.headlines || recommendedAssets.ShortHeadlines || [];
    const longHeadlines = recommendedAssets.longHeadlines || recommendedAssets.LongHeadlines || [];
    const descriptions = recommendedAssets.descriptions || recommendedAssets.Descriptions || [];
    const TextAssets = recommendedAssets.TextAssets || [];

    const headlineRecommendations = _.map(headlines, headline => _.pick(headline, 'RecommendationId', 'Text'));
    const longHeadlineRecommendations = _.map(longHeadlines, headline => _.pick(headline, 'RecommendationId', 'Text'));
    const descriptionRecommendations = _.map(descriptions, description => _.pick(description, 'RecommendationId', 'Text'));
    const textRecommendations = _.map(TextAssets, textAsset => _.pick(textAsset, 'RecommendationId', 'Text'));

    this.trackingData.textSuggestions = _.flatten([this.trackingData.textSuggestions, headlineRecommendations, longHeadlineRecommendations, descriptionRecommendations, textRecommendations]);
  }

  trackSelectedImageAssets(recommendedAssets) {
    this.trackingData = this.trackingData || {};
    this.trackingData.imageSuggestions = this.trackingData.imageSuggestions || [];
    const ImageAssets = recommendedAssets.ImageAssets || [];
    this.trackingData.imageSuggestions = _.uniq(_.flatten([this.trackingData.imageSuggestions, _.map(ImageAssets, imageAsset => _.pick(imageAsset, 'suggestionId', 'imageId'))]));
  }

  trackViewedSuggestionIds(suggestionIds) {
    this.trackingData = this.trackingData || {};
    this.trackingData.viewedSuggestions = this.trackingData.viewedSuggestions || [];
    this.trackingData.viewedSuggestions = _.uniq(_.flatten([this.trackingData.viewedSuggestions, suggestionIds]));
  }

  getUntrackedViewedSuggestionIds(suggestionIds) {
    this.trackingData = this.trackingData || {};
    this.trackingData.viewedSuggestions = this.trackingData.viewedSuggestions || [];
    return _.difference(suggestionIds, this.trackingData.viewedSuggestions);
  }

  getInitialSuggestionsData() {
    const data = this.initialSuggestionsData;
    this.initialSuggestionsData = {};
    return data;
  }

  isInRemainingInitialSuggestions(property, asset) {
    if (!this.initialSuggestionsData[property]) return false;
    return _.find(this.initialSuggestionsData[property].remainingSuggestions, suggestion => asset === suggestion);
  }

  trackInitialSuggestions(property, suggestions) {
    this.initialSuggestionsData[property] = { prefilledCount: _.size(suggestions), remainingSuggestions: suggestions };
  }

  removeAllInitialSuggestions() {
    this.initialSuggestionsData = _.mapObject(this.initialSuggestionsData, ({ prefilledCount }) => ({ prefilledCount, remainingSuggestions: [] }));
  }

  removeInitialSuggestion(property, suggestion) {
    if (!this.initialSuggestionsData[property]) return;
    this.initialSuggestionsData[property].remainingSuggestions = _.without(this.initialSuggestionsData[property].remainingSuggestions, suggestion);
  }
}
